export const DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH = 795
export const DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH = 480
